import { VEHICLE_COMPONENT } from 'features/VehicleTemplates/components/Components/constants'

export const getCapacity = (grid: TSFixMe): TSFixMe => {
  let capacity = 0

  grid.forEach((floor: TSFixMe): TSFixMe => {
    floor.forEach((row: TSFixMe): TSFixMe => {
      row.forEach((cell: TSFixMe): TSFixMe => {
        if (cell.component === VEHICLE_COMPONENT.SEAT) {
          capacity++
        }
      })
    })
  })

  return capacity
}

export const resolvers = {
  VehicleTemplate: {
    capacity(template: TSFixMe) {
      return getCapacity(template.layout)
    }
  }
}
